import { MarketUnit } from '../modules/shared/models/symbol.model';
import { BlackScholesType } from './black-scholes-calculator';

export const isOptionSymbol = (marketUnit: number) =>
	isOptionBuyMarketUnits(marketUnit) || isOptionSellMarketUnits(marketUnit);

export const isOptionBuyMarketUnits = (marketUnit: number) => {
	return [MarketUnit.BuyOptiontse, MarketUnit.BuyOptionifb].includes(marketUnit);
};
export const isOptionSellMarketUnits = (marketUnit: number) => {
	return [MarketUnit.SellOptiontse, MarketUnit.SellOptionifb].includes(marketUnit);
};

export const OptionMarketUnitsType: Record<number, BlackScholesType> = {
	[MarketUnit.BuyOptiontse]: BlackScholesType.Call,
	[MarketUnit.BuyOptionifb]: BlackScholesType.Call,
	[MarketUnit.SellOptiontse]: BlackScholesType.Put,
	[MarketUnit.SellOptionifb]: BlackScholesType.Put
};
